import axios from "axios";

export const loadAllAnalyticalNotesAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&siteId=${
        payload.siteId
      }&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleAnalyticalNoteAPI = (payload) => {
  return axios
    .get(`/analyticalNotes/${payload.analyticalNoteId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
